import { isJsonObject, type JsonValue } from '@protobuf-ts/runtime';
import { isEqual } from 'lodash-es';

import { AssertionError } from '$lib/assert';
/**
 * Compare two objects, returning `true` if their values do not match.
 */
export const areObjectsUnique = (
  a: JsonValue,
  b: JsonValue | undefined
): boolean => {
  if (b === undefined) {
    return true;
  }

  if (!isJsonObject(a) || !isJsonObject(b)) {
    throw new AssertionError('Value must be JSON object');
  }

  return !isEqual(a, b);
};
